import { AxiosError } from "axios";
import useSWR from "swr";
import { GenericErrorResponse, GetSettlementHistory200Response } from "../../../codegen-api";
import { APIEndpointEnum } from "../../../enums/endpoint";
import { publicApi } from "../../../services/api/apiFetcher";
import { AssetResponse } from "../../../utils/asset";

export const useSettlementHistory = (asset?: AssetResponse, startTime?: number, endTime?: number, limit?: number) => {
  const fetcher = publicApi();

  const swr = useSWR<GetSettlementHistory200Response[], AxiosError<GenericErrorResponse>>(
    [APIEndpointEnum.SETTLEMENT_HISTORY, asset],
    async () => {
      const { data } = await (await fetcher.getSettlementHistory(asset, startTime, endTime, limit))();
      // Handle both array response and object response with settlement_history field
      return Array.isArray(data) ? data : (data as any).settlement_history ?? [];
    },
    {
    },
  );

  return swr;
};
